var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERSION = void 0;
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
exports.VERSION = "0.0.37";
//# sourceMappingURL=version.js.map
export default exports;